import i18n from '@/i18n';
/** 工作台展示用：优先昵称，其次脱敏手机号，最后「我」 */
export function resolveAuthDisplayName(user) {
  const nickname = (user?.nickname && String(user.nickname).trim()) || '';
  if (nickname) return nickname;
  const phone = user?.phone ? String(user.phone) : '';
  if (phone.length >= 7) return `${phone.slice(0, 3)}****${phone.slice(-4)}`;
  return i18n.t('workbench:ipeUtilError.scopeMe');
}

/** 登录账号展示：优先完整手机号，其次 username / email */
export function resolveAuthAccountLabel(user) {
  if (!user || typeof user !== 'object') return '';
  const phone = String(user.phone || '').trim();
  if (phone) return phone;
  const username = String(user.username || '').trim();
  if (username) return username;
  const email = String(user.email || '').trim();
  if (email) return email;
  return '';
}
